<div class="verify-box">
	<span class="close-btn" (click)="closeDialog()">&#x2715;</span>
	<img src="assets/images/email.png" class="img-fluid mb-2 email-img" width="100" />
	<h2 class="create-account">Verify Your Email</h2>
	<p class="sub-head">
		We've sent a 6-digit verification code to your email.<br />Please enter it
		below to verify your account.
	</p>

	<div class="otp-inputs">
		<input *ngFor="let input of otpArray; let i = index" type="text" maxlength="1"
			(input)="handleOtpInput($event, i)" [(ngModel)]="otpValues[i]" 
			  (keydown)="handleKeyDown($event, i)"/>
	</div>

	<button class="verify-btn" [disabled]="!isOtpFilled() ||isLoading" (click)="verifyOtp()">
		<ng-container *ngIf="isLoading; else noLoading">
			<span class="spinner-text justify-content-center">
				<mat-spinner [diameter]="20"class="spinner-white"></mat-spinner>
			    Verfying...</span> 
			</ng-container>
			<ng-template #noLoading>Verify & Continue</ng-template>
	</button>

	<p class="resend-text">
		Didn’t receive the code?
		<a (click)="resendOtp()">
	<ng-container *ngIf="isSendingOtp; else noOtpSending">
	<span class="spinner-text justify-content-center">Sending OTP...</span></ng-container>
	<ng-template #noOtpSending>Resend code</ng-template></a>
	</p>
</div>